jQuery(function($)
{
    var
        $body = $('body'),
        delayMouseleave = 300,
        delayMouseenter = 300,
        { hide } = orion,
        { toggleExclusive } = orion,
        { showExclusive } = orion;

    function handleDropdownTriggerClick(e)
    {
        console.log('dropdown.js handleDropdownTriggerClick()');
        var
            $this = $(this),
            promise = $this.data('dropdown-promise');

        e.preventDefault();

        if (promise)
        {
            promise = orion[promise]();
        }
        else
        {
            promise = $.Deferred();
            promise.resolve();
        }

        promise.done(function()
        {
            var
                $target = $this.data('target');
            let $dropdownTarget = $('#' + $this.data('target'));

            if ($target == 'nav-main')
            {
                $('#nav-onsite').toggleClass('open');
            }

            toggleExclusive($dropdownTarget, $('.dropdown'));
        });
    }

    function handleDropdownTriggerMouseenter()
    {
        var
            $this = $(this),
            promise = $this.data('dropdown-promise');

        if (promise)
        {
            promise = orion[promise]();
        }
        else
        {
            promise = $.Deferred();
            promise.resolve();
        }

        promise.done(function()
        {
            var $dropdownTarget = $('#' + $this.data('target'));

            showExclusive($dropdownTarget, $('.dropdown'));

            $dropdownTarget.trigger(orion.constants.EventDropdownOpened);
        });
    }

    function handleDropdownTriggerMouseenterDelayed()
    {
        var self = this;

        if (self.timeoutMouseenterDelayed)
        {
            clearTimeout(self.timeoutMouseenterDelayed);
            self.timeoutMouseenterDelayed = false;
        }

        self.timeoutMouseenterDelayed = setTimeout(function()
        {
            self.timeoutMouseenterDelayed = false;
            handleDropdownTriggerMouseenter.apply(self);
        }, delayMouseenter);
    }

    function handleDropdownTriggerMouseenterDelayedTouchstart(e)
    {
        var $targetElement = $('#' + $(this).data('target'));

        if ($(this).hasClass(orion.constants.ClassTouchToClick)
			|| ($targetElement.length && $targetElement.hasClass('hidden') === false))
        {
            return;
        }

        handleDropdownTriggerClick.apply(this, [e]);
    }

    function handleDropdownTriggerMouseleave()
    {
        var $dropdownTarget = $('#' + $(this).data('target'));

        hide($dropdownTarget);
    }

    function handleDropdownTriggerMouseleaveDelayed()
    {
        var self = this;

        if (self.timeoutMouseenterDelayed)
        {
            clearTimeout(self.timeoutMouseenterDelayed);
            self.timeoutMouseenterDelayed = false;
        }

        if (self.timeoutMouseleaveDelayed)
        {
            clearTimeout(self.timeoutMouseleaveDelayed);
            self.timeoutMouseleaveDelayed = false;
        }

        self.timeoutMouseleaveDelayed = setTimeout(function()
        {
            self.timeoutMouseleaveDelayed = false;
            handleDropdownTriggerMouseleave.apply(self);
        }, delayMouseleave);
    }

    function handleDropdownCloseClick(e)
    {
        console.log('dropdown.js handleDropdownCloseClick()');
        e.preventDefault();

        var $dropdownTarget = $(this).closest('.dropdown, .dropdown-mobile');

        hide($dropdownTarget);
    }

    function handleDropdownMouseenter()
    {
        var
            $this = $(this),
            id = $this.attr('id');

        $('[data-target=' + id + ']').each(function()
        {
            if (this.timeoutMouseleaveDelayed)
            {
                clearTimeout(this.timeoutMouseleaveDelayed);
                this.timeoutMouseleaveDelayed = false;
            }
        });
    }

    function handleDropdownMouseleave()
    {
        hide($(this));
    }

    function handleDropdownMouseleaveDelayed()
    {
        var
            $this = $(this),
            id = $this.attr('id');

        $('[data-target=' + id + ']').each(function()
        {
            handleDropdownTriggerMouseleaveDelayed.apply(this);
        });
    }

    function handleDropdownCloseOnClickAnywhere(e)
    {
        console.log('handleDropdownCloseOnClickAnywhere');

        let isClickInsideDropdown = false;

        if ($(e.target).closest('.dropdown-trigger').length)
        {
            isClickInsideDropdown = true;
        }

        $('.dropdown').each(function()
        {
            let $dropdown = $(this);

            if ($.contains($dropdown.get(0), e.target))
            {
                isClickInsideDropdown = true;
            }
        });

        if (isClickInsideDropdown)
        {
            return;
        }

        hide($('.dropdown').not('.mega')
            .not('.hidden'));
        $('.dropdown-trigger').removeClass('primary dropdown-active');
    }

    $body
        .on('click', '.dropdown-trigger', handleDropdownTriggerClick)
        .on('mouseenter', '.dropdown-trigger-hover, .dropdown-trigger-enter', handleDropdownTriggerMouseenter)
        .on('mouseleave', '.dropdown-trigger-hover', handleDropdownTriggerMouseleave)
        .on('mouseenter', '.dropdown-trigger-hover-delayed', handleDropdownTriggerMouseenterDelayed)
        .on('mouseleave', '.dropdown-trigger-hover-delayed', handleDropdownTriggerMouseleaveDelayed)
        .on('touchstart', '.dropdown-trigger-hover-delayed', handleDropdownTriggerMouseenterDelayedTouchstart)
        .on('click', '.dropdown .close, .dropdown-mobile .close', handleDropdownCloseClick)
        .on('mouseenter', '.dropdown', handleDropdownMouseenter)
        .on('mouseleave', '.dropdown.dropdown-leave', handleDropdownMouseleave)
        .on('mouseleave', '.dropdown.dropdown-leave-delayed', handleDropdownMouseleaveDelayed)
        .on('click', handleDropdownCloseOnClickAnywhere);
});
